<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->

<gh-ext-dialog layout="text" forBreakpoint="lt-xl">
  <gh-ext-dialog-header title="{{'lbl_office_details' | translate}}"></gh-ext-dialog-header>
  <gh-ext-dialog-content>
    <gh-supplier-office-info class="m-office-info" [office]="office"></gh-supplier-office-info>
  </gh-ext-dialog-content>
  <gh-ext-dialog-button-bar align="center">
    <a *ngIf="office.phone" fxHide.gt-sm="" href="tel:{{ office.phone }}" mat-raised-button="" color="primary">{{'lbl_call_to_office' | translate}}</a>
    <button type="button" mat-raised-button="" fxHide.lt-md="" color="primary" class="large" (click)="onClose()">{{'lbl_ok' | translate}}</button>
  </gh-ext-dialog-button-bar>
</gh-ext-dialog>